import { useRef } from "react";

import Style from "./style";

import MainHeader from "widget/MainHeader";

import useGetMyStore from "entity/store/useGetMyStore";
import usePutMyStore from "entity/store/usePutMyStore";

import useLogoUpload from "entity/util/useLogoUpload";
import ITStyle from "shared/style/inputTableStyle";
import UploadImage from "shared/ui/UploadImage";

const MyStoreEdit = () => {
  const nameRef = useRef();
  const addressRef = useRef();
  const [myStoreData] = useGetMyStore();
  const { uploadImage, imgUrl, imgUrlRef, loading } = useLogoUpload(
    myStoreData?.data?.logo_img
  );
  const [putStore] = usePutMyStore(nameRef, addressRef, imgUrlRef);

  const btnList = [
    {
      label: "저장",
      clickEvent: () => {
        putStore();
      },
      deactive: false,
    },
  ];

  return (
    <Style.Wrapper>
      <MainHeader btnList={btnList} />

      <ITStyle.TableDiv>
        <ITStyle.TableElement>
          <h2>
            매장 이름<span>*</span>
          </h2>
          <input
            ref={nameRef}
            placeholder="40글자 이하"
            defaultValue={myStoreData?.data?.store_name}
          />
        </ITStyle.TableElement>
        <ITStyle.TableElement>
          <h2>
            매장 주소<span>*</span>
          </h2>
          <input
            ref={addressRef}
            defaultValue={myStoreData?.data?.store_address}
          />
        </ITStyle.TableElement>

        <ITStyle.TableElement>
          <h2>Logo</h2>
          <div className="upload-image-container">
            <UploadImage
              imgUrl={imgUrl}
              loading={loading}
              uploadImage={uploadImage}
            />

            <ITStyle.GuideDiv>
              <p>jpg, png 이미지 | 20mb 제한</p>
            </ITStyle.GuideDiv>
          </div>
        </ITStyle.TableElement>
      </ITStyle.TableDiv>
    </Style.Wrapper>
  );
};

export default MyStoreEdit;
